const tens = [
  {
    key: 'derbund',
    name: 'der Bund',
    domain: 'derbund',
    feedId: 1,
    lang: 'de',
  },
  {
    key: 'tagesanzeiger',
    name: 'Tages-Anzeiger',
    domain: 'tagesanzeiger',
    feedId: 2,
    lang: 'de',
  },
  {
    key: 'bernerzeitung',
    name: 'Berner Zeitung',
    domain: 'bernerzeitung',
    feedId: 3,
    lang: 'de',
  },
  {
    key: 'bazonline',
    name: 'Basler Zeitung',
    domain: 'bazonline',
    feedId: 5,
    lang: 'de',
  },
  {
    key: 'berneroberlaender',
    name: 'Berner Oberländer',
    domain: 'berneroberlaender',
    feedId: 8,
    lang: 'de',
  },
  {
    key: 'thunertagblatt',
    name: 'Thuner Tagblatt',
    domain: 'thunertagblatt',
    feedId: 9,
    lang: 'de',
  },
  {
    key: 'langenthalertagblatt',
    name: 'Langenthaler Tagblatt',
    domain: 'langenthalertagblatt',
    feedId: 10,
    lang: 'de',
  },
  {
    key: 'zsz',
    name: 'Zürichsee-Zeitung',
    domain: 'zsz',
    feedId: 11,
    lang: 'de',
  },
  {
    key: 'landbote',
    name: 'Der Landbote',
    domain: 'landbote',
    feedId: 12,
    lang: 'de',
  },
  {
    key: 'zuonline',
    name: 'Zürcher Unterländer',
    domain: 'zuonline',
    feedId: 13,
    lang: 'de',
  },
  {
    key: 'tdg',
    name: 'Tribune de Genève',
    domain: 'tdg',
    feedId: 14,
    lang: 'fr',
  },
  {
    key: '24heures',
    name: '24 heures',
    domain: '24heures',
    feedId: 15,
    lang: 'fr',
  },
  {
    key: 'bilan',
    name: 'Bilan',
    domain: 'bilan',
    feedId: 17,
    lang: 'fr',
  },
]

export default tens
